import React, { useState, useEffect, useRef, useContext } from "react";
import { Alert } from "reactstrap";
import Pagination from '../../components/pagination/pagination';
import EmployeeAccountsTable from "../../components/employeeAccountsTable";
import EmployeeAccountsTableModal from "../../components/employeeAccountsTableModal";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import { getCookie } from "../../jwt/_helpers/cookie";
import { useFetch } from "../../utils/fetchHook";
import { getUser } from "../../utils/getUser";
import { Link } from "react-router-dom";

import {StateContext} from "../../utils/context";
import { isDemoLocked } from "../../utils/demoConfig";

const EmployeeAccounts = props => {
  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [updateTitle, setUpdateTitle] = useState("");
  const [updateBody, setUpdateBody] = useState("");
  const [updateData, setUpdateData] = useState({});
  const [updateBtnText, setUpdateBtnText] = useState("");
  const [updateBtnColor, setUpdateBtnColor] = useState("");
  
  const token = getCookie("token");
  const {currentUser,setCurrentUser} = useContext(StateContext);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);
  const [forceUpdate, setForce] = useState(1);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '', name: 'id', sort: 'id'});


  const [apiData, error, loading] = useFetch("GET",`employee-accounts/?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&search=${query}`,token,false,forceUpdate);
  const [tableData, setTableData] = useState([]);

  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);
 
  const [lastAction, setLastAction] = useState("updated");

  useEffect(() => {
    if (apiData?.results) {
      setTableData(apiData.results);
    }
    if (apiData?.count != null) {
      setDataCount(apiData.count);
    }
  }, [apiData]);


  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  useEffect(() => {
    if (isDemoLocked()) {
      return;
    }
    getUser(token, currentUser, setCurrentUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error]);

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const handlerValues = { setSuccess, setError, forceUpdate, setForce };

  return (
    <>
      {
        !isDemoLocked() && (!currentUser.is_premium_user || !currentUser.employee_accounts) && (
          <Alert color="danger">
            Employee accounts are offered with <Link to="/sla">Gold Plan SLA</Link> only. Please <Link to="/sla">upgrade your account</Link> in order to avail this feature.
          </Alert>        
        )
      }

      {
        loading ? (
          <TableHelper loading />
        ) : error ? (
          <TableHelper error />
        ) :  (
        <div>
          {
            !isDemoLocked() && currentUser.total_employee_accounts >= 10 && (
              <Alert color="warning">
                You have reached the limit of <b>10 employee accounts</b>, If you want to add a new employee account, you can do that by deleting an existing one.
              </Alert>
            )
          }
          <ViewLayout title={"Your employee accounts list"}>
            <EmployeeAccountsTable
              setToggleModal={setToggleModal}
              setDataModal={setDataModal}
              setUpdateBody={setUpdateBody}
              setUpdateTitle={setUpdateTitle}
              setUpdateData={setUpdateData}
              setUpdateBtnText={setUpdateBtnText}
              setUpdateBtnColor={setUpdateBtnColor}
              setLastAction={setLastAction}
              forceUpdate={forceUpdate}
              data={tableData}
              defaultSorted={defaultSorted}
              searchQuery={{setQuery, query, ordering, setOrdering}}
              editDisabled={isDemoLocked()}
            />
          </ViewLayout>
          <Pagination pagination={paginationProps}/>
        </div>
      ) }
        
      
      {dataModal && (
        <EmployeeAccountsTableModal
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          values={handlerValues}
          title={updateTitle}
          body={updateBody}
          updateBtnText={updateBtnText}
          updateBtnColor={updateBtnColor}
          apiURL={`employee-accounts/${dataModal.id}`}
          bodyID={dataModal.id}
          updateData={updateData}
        />
      )}
      {success && <Alert color="success">{lastAction}</Alert>}
      {errorPut && (
        <Alert color="danger">
          Something went wrong! Please refresh page and try again!
        </Alert>
      )}
    </>
  );
};

export default EmployeeAccounts;
